import React from "react";
import Badge from "../Badge/Badge";
import FeatherIcon from "feather-icons-react";
import "./DriveHeader.css";
import ProfileMatch from "../Profile Match/ProfileMatch";
import api from "../../api";
import { toast } from "react-toastify";

function parseRoleType(role) {
  switch (role) {
    case "fulltime":
      return "Full Time";
    case "part-time":
      return "Part Time";
    case "internship":
      return "Internship";
    case "contract":
      return "Contract";
    default:
      return "Full Time";
  }
}

const DriveHeader = ({ job }) => {
  const handleSave = () => {
    api.post(`/student/${job._id}/bookmark`)
    .then((response) => {
      toast.success("Job Saved!!")
    })
    .catch((error)=>{
      toast.error("Server Error!!")
    });
  };
  return (
    <div className="driveitem-root">
      <div className="drive-header-root">
        <div className="drive-header">
          <img src={job.company.logoUrl} height={60} className="drive-logo" />
          <div className="drive-header-group">
            <p className="drive-company">
              {job.company.name}
            </p>
            <p className="drive-role">{job.role}</p>
          </div>
        </div>
        {/* <Badge
              icon={"x"}
              text={"Not Eligible To Apply"}
              color="#d65885"
              backgroundColor="#fbeff5"
            /> */}
          <Badge
              icon={"check"}
              text={"Eligible To Apply"}
              color="green"
              backgroundColor="#e7fde8"
            />
        {/* <ProfileMatch /> TODO:Do we need this? */}
      </div>
      <div className="drive-body-root">
        <div className="drive-body-top">
        <div className="drive-badge-group">
          <Badge
            icon={"clock"}
            text={new Date(job.regitrationDeadline).toLocaleString("en-in", {
              month: "short",
              year: "numeric",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
            color="#e67300"
            backgroundColor="#fff2e6"
          />
          <Badge icon={"map-pin"} text={job.location} />
          {job.bondApplicable && (
            <Badge
              icon={"file-text"}
              text={`${job.bondDuration} Year Bond`}
              color="#da5885"
              backgroundColor="#fbeff5"
            />
          )}
          <Badge icon={"users"} text={job.noOfPositions + " positions"} />
          <Badge icon={"briefcase"} text={job.jobType} />
        </div>
            </div>
        <div className="drive-quick-action-root" style={{marginTop: 30}}>
            <div className="drive-salary">
              <p className="drive-salary-icon">₹</p>
              <p className="drive-salary-text">
                {job.ctc.toLocaleString("en-IN")} LPA
              </p>
            </div>
            <div style={{display: "flex",alignItems: "center"}}>
            <div className="save-job" onClick={handleSave} style={{padding: 12,marginRight: 15}}>
            <FeatherIcon
              icon={"bookmark"}
              color="#213780"
              size={17}
            />
          </div>
          <button className="drive-apply-button">Apply To Drive</button>
            </div>
        </div>
      </div>
      <hr className="job-hr" />
    </div>
  );
};

export default DriveHeader;
